import React, { useEffect, useRef, useState } from 'react';
import './HeroBot.css';

const MODEL_URL = `${process.env.PUBLIC_URL}/models/zinify-bot.glb`;
/* Blender still of the same model — shown when WebGL is unavailable */
const FALLBACK_URL = `${process.env.PUBLIC_URL}/models/zinify-bot.webp`;

type Status = 'loading' | 'ready' | 'fallback';

const HeroBot: React.FC = () => {
  const stageRef = useRef<HTMLDivElement>(null);
  const [status, setStatus] = useState<Status>('loading');
  const [reducedMotion] = useState(
    () => window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );

  useEffect(() => {
    const stage = stageRef.current;
    if (!stage) return;
    let disposed = false;
    let dispose: (() => void) | undefined;

    // three.js is the heaviest dependency on the page: load it on demand
    import('./botScene')
      .then(({ mountBot }) => {
        if (disposed) return;
        dispose = mountBot(stage, {
          url: MODEL_URL,
          reducedMotion,
          onReady: () => !disposed && setStatus('ready'),
          onError: () => !disposed && setStatus('fallback'),
        });
      })
      .catch(() => !disposed && setStatus('fallback'));

    return () => {
      disposed = true;
      dispose?.();
    };
  }, [reducedMotion]);

  return (
    <figure className={`herobot herobot--${status}`}>
      <div className="herobot__stage" ref={stageRef}>
        {status === 'fallback' && (
          <img className="herobot__still" src={FALLBACK_URL} alt="" />
        )}
      </div>
      <figcaption className="visually-hidden">
        The ZinifyLabs mascot, a small indigo robot that waves when you tap it.
      </figcaption>
    </figure>
  );
};

export default HeroBot;
